import {
    Link, useParams,
} from "react-router-dom";
import {PublicationsList} from "./Posts";

export function Publications() {
    return PublicationsList.map((publication) => {
        let linkSetup = {
            link : publication.link,
            label : "Otvoriť"
        }
        let secondLinkSetup = {
            link : "",
            label : "Viac o projekte"
        }
        if(publication.secondLink) {
            if(typeof publication.secondLink === "object") {
                secondLinkSetup.link = publication.secondLink.link;
                secondLinkSetup.label = publication.secondLink.label;
            } else {
                secondLinkSetup.link = (publication as any).secondLink;
            }
        } else {
            secondLinkSetup = null;
        }
        return <div className="publication-card" key={publication.id}>
            <div className="card-cover" style={{
                backgroundImage: "url(" + publication.banner + ")"
            }}></div>

            <div className="card-header">
                <div className="heading">{publication.heading}</div>
            </div>
            <div className="card-links">
                {
                    <Link to={linkSetup.link}>{linkSetup.label}</Link>
                }
                {
                    secondLinkSetup &&
                    <Link to={secondLinkSetup.link}>{secondLinkSetup.label}</Link>
                }
            </div>
        </div>
    })
}